module.exports = __webpack_public_path__ + "img/home-arguments-noalcohol.78a989bb.svg";